import {Component} from 'panel';

import {Persistence} from './persistence';
import {debug} from './util';

// TODO: deprecate this, only used in correlate-app
export class MPApp extends Component {
  connectedCallback() {
    Object.assign(this.state, this.deserialize(this.persistence.get(`state`)));
    super.connectedCallback(...arguments);
    this.initClickOutside();
  }

  initialURLHash() {
    return this.parentData.hash.replace(/^#*/, `#`);
  }

  // serialization helpers

  get persistence() {
    if (!this._persistence) {
      let namespaceVars = [this.persistenceKey];
      if (this.parentData) {
        /* eslint-disable camelcase */
        const {project_id, user_id} = this.parentData;
        namespaceVars = namespaceVars.concat([project_id, user_id]);
        /* eslint-enable camelcase */
      }
      this._persistence = new Persistence(namespaceVars.join(`:`));
    }

    return this._persistence;
  }

  get persistenceKey() {
    throw new Error(`override persistenceKey for app-specific storage entries and versioning`);
  }

  serialize() {
    return JSON.stringify(this.toSerializationAttrs());
  }

  deserialize(JSONstr) {
    let persisted = null;
    try {
      persisted = this.fromSerializationAttrs(JSON.parse(JSONstr));
    } catch (err) {
      if (JSONstr) {
        debug.warn(`Invalid persistence entry: ${JSONstr}`);
      }
    }

    return persisted || {};
  }

  toSerializationAttrs() {
    return {};
  }

  fromSerializationAttrs(attrs) {
    return attrs;
  }

  // DOM helpers

  initClickOutside() {
    document.addEventListener(`click`, (ev) => this.clickOutsideHandler(ev));
  }

  onClickOutside(tagName, appMethodName) {
    this.clickOutsideHandlers = this.clickOutsideHandlers || {};
    this.clickOutsideHandlers[appMethodName] = this.clickOutsideHandlers[appMethodName] || [];

    if (this.clickOutsideHandlers[appMethodName].indexOf(tagName) === -1) {
      this.clickOutsideHandlers[appMethodName].push(tagName);
    }
  }

  clickOutsideHandler(ev) {
    this.clickOutsideHandlers = this.clickOutsideHandlers || {};
    Object.keys(this.clickOutsideHandlers).forEach((appMethodName) => {
      const tagNames = this.clickOutsideHandlers[appMethodName];

      for (let el = ev.target; el; el = el.parentElement) {
        if (tagNames.includes(el.tagName)) {
          return;
        }
      }

      this[appMethodName](ev);
    });
  }
}
